const Header=()=>{
    return(
        <>
            <div className="header">
                        <div className="myName">
                            <p><span className="anayt">ANAYT</span>RAHMAN.GITHUB.IO</p>
                        </div>
            </div>
           
        </>
    )
}

export default Header;